const win: any = window;
/**
 * 数值处理函数 用于处理表格和浮窗显示的数据
 * @param value { any } 传入的数据
 * @param unit { string } 处理数据的单位
 * @param { boolean } isShowUnit 是否显示单位
 */
const formateData = (value: number | string, unit: string) => {
  const moneyTypeList = ['元'];
  const moneyWanTypeList = ['万元'];
  const moneyFoldTypeList = ['亿元'];
  const stockTypeList = ['股', '张', '人'];
  const stockFoldTypeList = ['万股', '万张', '万人'];
  const ttmTypeList = ['ttm'];
  const specialTypeList = ['winning'];
  const specialTypeRateList = ['premium', 'rate'];
  const specialTypeMoneyList = ['issue'];
  const dateTypeList = ['date'];
  // 无数据
  if (!value && value !== 0 && value !== 'null') {
    return '--';
  }

  // 单位 %  涨幅数据，小于0.01出现小于号
  if (unit === '%') {
    const resData = win.F10Utils.formatPercent(Number(value) / 100, false);
    return resData.value + resData.unit;
  }

  // 中签率 保留四位小数的%
  if (specialTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.handleRetainNew(value, 4);
    return resData + '%';
  }

  // 溢价率 净利润增长率 占比 保留两位小数的%
  if (specialTypeRateList.indexOf(unit) > -1) {
    const resData = win.F10Utils.handleRetainNew(value, 2);
    return resData + '%';
  }

  // 单位 元 保留四位有效数字
  if (moneyTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.formatMoney(value, false);
    return resData.value + resData.unit + '元';
  }

  // 万元 保留四位有效数字
  if (moneyWanTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.formatMoney(Number(value) * 10000, false);
    return resData.value + resData.unit + '元';
  }

  // 亿元 保留四位有效数字
  if (moneyFoldTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.formatMoney(Number(value) * 100000000, false);
    return resData.value + resData.unit + '元';
  }

  // 发行价 每股获配额等  保留两位小数的价格元
  if (specialTypeMoneyList.indexOf(unit) > -1) {
    const resData = win.F10Utils.handleRetainNew(value, 2);
    return resData + '元';
  }

  // 单位 股 张 人
  if (stockTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.formatStock(value);
    return resData.value + resData.unit + unit;
  }

  // 单位 万股 万张 万人
  if (stockFoldTypeList.indexOf(unit) > -1) {
    const newValue = Number(value) * 10000;
    const resData = win.F10Utils.formatStock(newValue);
    return resData.value + resData.unit + unit[1];
  }

  // 市盈率ttm  保留两位小数，且负数显示亏损
  if (ttmTypeList.indexOf(unit) > -1) {
    const resData = win.F10Utils.formatEvalute(value, false, true);
    return resData.value + resData.unit;
  }

  // 日期
  if (dateTypeList.indexOf(unit) > -1) {
    const year = String(value).slice(0,4);
    const month = String(value).slice(4,6);
    const day = String(value).slice(6);
    return year + '/' + month + '/' + day;
  }

  // 无单位处理
  if (!unit) {
    return value;
  }
  // 其他单位 年
  return value + unit;
};

export default formateData;
